export default "__VITE_ASSET__DoD$Gxpu__"